import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './rootReducer';

const composeEnhancers = composeWithDevTools({ name: `Bongo[${window.location.origin}${window.location.pathname}]` });
const store = createStore(rootReducer, composeEnhancers());
export default store;
